import { render, staticRenderFns } from "./mediaSwiper.vue?vue&type=template&id=3bd9e682&name=mediaSwiper&"
import script from "./mediaSwiper.vue?vue&type=script&lang=js&"
export * from "./mediaSwiper.vue?vue&type=script&lang=js&"
import style0 from "./mediaSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports